import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { withKeys as _withKeys, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", null, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, null, -1)
const _hoisted_3 = {
  key: 0,
  class: "mt-6 space-y-4 md:space-y-8"
}
const _hoisted_4 = { class: "flex flex-wrap items-end space-x-6" }
const _hoisted_5 = { class: "flex items-center justify-between" }
const _hoisted_6 = { class: "pt-0" }
const _hoisted_7 = ["href"]
const _hoisted_8 = { class: "flex items-center justify-between" }
const _hoisted_9 = { style: {"padding-right":"20px"} }
const _hoisted_10 = {
  key: 1,
  class: "mt-8 overflow-clip"
}
const _hoisted_11 = {
  key: 0,
  class: "mt-8 md:mt-2"
}
const _hoisted_12 = { class: "mt-2 border border-gray-400 rounded" }
const _hoisted_13 = { class: "capitalize" }
const _hoisted_14 = { class: "pt-0 mt-0 text-gray-800" }
const _hoisted_15 = { class: "capitalize" }
const _hoisted_16 = { class: "capitalize" }
const _hoisted_17 = { class: "space-y-2.5" }
const _hoisted_18 = { class: "space-y-2.5" }
const _hoisted_19 = { class: "pt-0 capitalize" }
const _hoisted_20 = { class: "pt-0 capitalize" }
const _hoisted_21 = { class: "pt-0 capitalize" }
const _hoisted_22 = { class: "pt-0 capitalize" }
const _hoisted_23 = { class: "pt-0 capitalize" }
const _hoisted_24 = { class: "pt-0 capitalize" }
const _hoisted_25 = { class: "pt-0" }
const _hoisted_26 = { class: "w-full border-b border-gray-300" }
const _hoisted_27 = { class: "flex w-full px-4 py-2 md:w-1/2 lg:w-2/3" }
const _hoisted_28 = { class: "text-lg font-medium capitalize" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "w-full px-4 pb-2 md:py-2" }, null, -1)
const _hoisted_30 = { class: "overflow-x-auto" }
const _hoisted_31 = { class: "w-full table-auto" }
const _hoisted_32 = { class: "font-bold text-left border-b-2 border-black divide-x-2 divide-gray-400" }
const _hoisted_33 = {
  scope: "col",
  class: "w-1/4 px-2 py-2 capitalize"
}
const _hoisted_34 = {
  scope: "col",
  class: "w-1/4 px-2 py-2 whitespace-nowrap md:whitespace-normal"
}
const _hoisted_35 = {
  scope: "col",
  class: "w-1/4 px-2 py-2"
}
const _hoisted_36 = {
  scope: "col",
  class: "w-1/4 px-2 py-2 capitalize"
}
const _hoisted_37 = { class: "w-64 px-2 py-3 capitalize whitespace-nowrap md:whitespace-normal" }
const _hoisted_38 = { class: "w-64 px-6 py-3 capitalize" }
const _hoisted_39 = { class: "w-64 px-6 py-3 capitalize" }
const _hoisted_40 = { class: "w-64 px-6 py-3 capitalize" }
const _hoisted_41 = { class: "pt-0" }
const _hoisted_42 = {
  key: 0,
  class: "flex flex-wrap gap-4 py-6"
}
const _hoisted_43 = {
  key: 2,
  class: "mt-8 md:mt-2"
}
const _hoisted_44 = { class: "text-3xl font-medium capitalize" }
const _hoisted_45 = { key: 0 }
const _hoisted_46 = { key: 0 }
const _hoisted_47 = {
  key: 1,
  class: "mt-6 overflow-x-auto"
}
const _hoisted_48 = { class: "w-full table-auto" }
const _hoisted_49 = { class: "font-bold text-left border-b-2 border-black" }
const _hoisted_50 = {
  scope: "col",
  class: "px-4 py-2 capitalize"
}
const _hoisted_51 = { key: 0 }
const _hoisted_52 = { class: "w-64 px-4 py-6 capitalize md:py-3 whitespace-nowrap" }
const _hoisted_53 = {
  key: 0,
  class: "relative group"
}
const _hoisted_54 = {
  key: 0,
  class: "absolute z-20 px-1 m-1 mx-auto text-sm text-gray-100 transition-opacity bg-gray-800 rounded-md opacity-0 cursor-not-allowed w-fit -translate-x-1/3 -translate-y-1/3 bottom-6 group-hover:opacity-100"
}
const _hoisted_55 = { key: 1 }
const _hoisted_56 = { class: "border-b border-gray-400" }
const _hoisted_57 = { class: "px-2 py-6 md:py-3 whitespace-nowrap" }
const _hoisted_58 = { class: "border-b border-gray-400" }
const _hoisted_59 = { class: "px-2 py-6 md:py-3 whitespace-nowrap" }
const _hoisted_60 = {
  key: 3,
  class: "mt-8 md:mt-2 overflow-clip"
}
const _hoisted_61 = { key: 0 }
const _hoisted_62 = { key: 0 }
const _hoisted_63 = { class: "text-3xl font-medium" }
const _hoisted_64 = ["href"]
const _hoisted_65 = { class: "py-2 ml-6 list-disc" }
const _hoisted_66 = { class: "w-full mt-6 table-fixed" }
const _hoisted_67 = { class: "font-bold text-left border-b-2 border-black" }
const _hoisted_68 = {
  scope: "col",
  class: "px-2 py-2 capitalize"
}
const _hoisted_69 = {
  key: 0,
  class: "px-2 py-2 capitalize"
}
const _hoisted_70 = { class: "px-2 py-2 capitalize" }
const _hoisted_71 = { class: "px-2 py-2" }
const _hoisted_72 = {
  key: 0,
  class: "px-2 py-2"
}
const _hoisted_73 = { class: "px-2 py-2" }
const _hoisted_74 = { key: 0 }
const _hoisted_75 = { class: "capitalize" }
const _hoisted_76 = { key: 1 }
const _hoisted_77 = { class: "border-b border-gray-400" }
const _hoisted_78 = /*#__PURE__*/_createElementVNode("td", { class: "px-2 py-2" }, null, -1)
const _hoisted_79 = {
  key: 0,
  class: "px-2 py-2"
}
const _hoisted_80 = { key: 1 }
const _hoisted_81 = { key: 1 }
const _hoisted_82 = {
  key: 4,
  class: "mt-8 md:mt-2"
}
const _hoisted_83 = { key: 0 }
const _hoisted_84 = { key: 0 }
const _hoisted_85 = { class: "flex flex-wrap items-center justify-between" }
const _hoisted_86 = { class: "text-3xl font-medium capitalize" }
const _hoisted_87 = { key: 0 }
const _hoisted_88 = { class: "mr-2" }
const _hoisted_89 = /*#__PURE__*/_createElementVNode("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_18809_4626)" }, [
    /*#__PURE__*/_createElementVNode("rect", {
      width: "16",
      height: "16",
      fill: "white",
      "fill-opacity": "0.01"
    }),
    /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip1_18809_4626)" }, [
      /*#__PURE__*/_createElementVNode("path", {
        d: "M0.5 9.89921C0.632608 9.89921 0.759785 9.95189 0.853553 10.0457C0.947322 10.1394 1 10.2666 1 10.3992V12.8992C1 13.1644 1.10536 13.4188 1.29289 13.6063C1.48043 13.7938 1.73478 13.8992 2 13.8992H14C14.2652 13.8992 14.5196 13.7938 14.7071 13.6063C14.8946 13.4188 15 13.1644 15 12.8992V10.3992C15 10.2666 15.0527 10.1394 15.1464 10.0457C15.2402 9.95189 15.3674 9.89921 15.5 9.89921C15.6326 9.89921 15.7598 9.95189 15.8536 10.0457C15.9473 10.1394 16 10.2666 16 10.3992V12.8992C16 13.4296 15.7893 13.9383 15.4142 14.3134C15.0391 14.6885 14.5304 14.8992 14 14.8992H2C1.46957 14.8992 0.960859 14.6885 0.585786 14.3134C0.210714 13.9383 0 13.4296 0 12.8992V10.3992C0 10.2666 0.0526784 10.1394 0.146447 10.0457C0.240215 9.95189 0.367392 9.89921 0.5 9.89921Z",
        fill: "white"
      }),
      /*#__PURE__*/_createElementVNode("path", {
        d: "M7.646 11.8532C7.69245 11.8998 7.74762 11.9367 7.80837 11.9619C7.86911 11.9871 7.93423 12.0001 8 12.0001C8.06577 12.0001 8.13089 11.9871 8.19163 11.9619C8.25238 11.9367 8.30755 11.8998 8.354 11.8532L11.354 8.85321C11.4479 8.75932 11.5006 8.63198 11.5006 8.49921C11.5006 8.36643 11.4479 8.23909 11.354 8.14521C11.2601 8.05132 11.1328 7.99857 11 7.99857C10.8672 7.99857 10.7399 8.05132 10.646 8.14521L8.5 10.2922V1.49921C8.5 1.3666 8.44732 1.23942 8.35355 1.14565C8.25979 1.05188 8.13261 0.999207 8 0.999207C7.86739 0.999207 7.74021 1.05188 7.64645 1.14565C7.55268 1.23942 7.5 1.3666 7.5 1.49921V10.2922L5.354 8.14521C5.26011 8.05132 5.13278 7.99857 5 7.99857C4.86722 7.99857 4.73989 8.05132 4.646 8.14521C4.55211 8.23909 4.49937 8.36643 4.49937 8.49921C4.49937 8.63198 4.55211 8.75932 4.646 8.85321L7.646 11.8532Z",
        fill: "white"
      })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("defs", null, [
    /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_18809_4626" }, [
      /*#__PURE__*/_createElementVNode("rect", {
        width: "16",
        height: "16",
        fill: "white"
      })
    ]),
    /*#__PURE__*/_createElementVNode("clipPath", { id: "clip1_18809_4626" }, [
      /*#__PURE__*/_createElementVNode("rect", {
        width: "16",
        height: "16",
        fill: "white"
      })
    ])
  ])
], -1)
const _hoisted_90 = { class: "w-full mt-6 table-auto" }
const _hoisted_91 = { class: "font-bold text-left border-b-2 border-black" }
const _hoisted_92 = { class: "px-2 py-2 capitalize" }
const _hoisted_93 = { class: "px-2 py-2" }
const _hoisted_94 = { class: "px-2 py-2" }
const _hoisted_95 = { class: "px-2 py-2" }
const _hoisted_96 = { class: "px-2 py-6 capitalize md:py-3 whitespace-nowrap" }
const _hoisted_97 = { class: "px-2 py-6 md:py-3 whitespace-nowrap" }
const _hoisted_98 = { class: "px-2 py-6 md:py-3 whitespace-nowrap" }
const _hoisted_99 = { class: "px-2 py-6 md:py-3 whitespace-nowrap" }
const _hoisted_100 = { key: 1 }
const _hoisted_101 = { key: 1 }
const _hoisted_102 = {
  key: 5,
  class: "mt-8 md:mt-2"
}
const _hoisted_103 = { key: 0 }
const _hoisted_104 = { key: 0 }
const _hoisted_105 = { class: "text-3xl font-medium" }
const _hoisted_106 = { key: 1 }
const _hoisted_107 = { key: 1 }

import { computed, onMounted, ref, watch } from "vue";
import { storeToRefs } from "pinia";
import { zonedTimeToUtc } from "date-fns-tz";
import { useRoute, useRouter } from "vue-router";

import DatePicker from "@vuepic/vue-datepicker";

import GroupGoalProgressChart from "@/components/charts/GroupGoalProgressChart.vue";
import ClubParticipantTable from "@/components/tables/ClubParticipantTable.vue";
import ClubVisibilitySwitch from "@/components/clubs/ClubVisibilitySwitch.vue";
import ConfirmationModal from "@/components/modals/ConfirmationModal.vue";
import StudentNoteModal from "@/components/modals/StudentNoteModal.vue";
import ClubNoteModal from "@/components/modals/ClubNoteModal.vue";
import ToggleCheckbox from "@/components/ToggleCheckbox.vue";
import DefaultButton from "@/components/DefaultButton.vue";
import ReadOnlyNote from "@/components/ReadOnlyNote.vue";
import RouterButton from "@/components/RouterButton.vue";
import ExternalLink from "@/components/ExternalLink.vue";
import ListRowItem from "@/components/ListRowItem.vue";
import TitleHeader from "@/components/TitleHeader.vue";
import AlertCard from "@/components/AlertCard.vue";
import RoleGuard from "@/components/RoleGuard.vue";
import TabGroup from "@/components/TabGroup.vue";

import api from "@/api/api";
import { Club, ClubNote, Student, Attendance, ClubDate } from "@/types";
import { useGlobalStore, useUserStore } from "@/store";
import { userHasRole } from "@/utils/roles";
import ClubStudentRouterButton from "@/components/clubs/ClubStudentRouterButton.vue";
import capitalize from "@/utils/capitalize";


export default /*#__PURE__*/_defineComponent({
  __name: 'ClubPage',
  async setup(__props) {

let __temp: any, __restore: any

const clubRoles = ["trainer-organisation", "admin", "advanced-facilitator", "certified-facilitator", "advanced-facilitator-trainee", "facilitator-organisation", "clubs-admin"];

const route = useRoute();
const router = useRouter();
const globalStore = useGlobalStore();
const { user, userIsAdmin, timezone } = storeToRefs(useUserStore());
const website_url = process.env.VUE_APP_WEBSITE_URL;

const isLoading = ref(true);
const hasSmartsurveyAccess = ref(false);

hasSmartsurveyAccess.value = user.value.has_smartsurvey_access;

const tabs = [
  {
    id: "summary",
    name: "summary",
    roles: [...clubRoles, "parent", "brick-club-family", "professional", "paid-professional"],
  },
  {
    id: "club_participants",
    name: "members",
    roles: clubRoles,
  },
  {
    id: "attendance",
    name: "attendance",
    role: "trainer",
    roles: [...clubRoles, "brick-club-family"],
  },
  {
    id: "session_notes",
    name: "facilitator-session-checklist",
    roles: clubRoles,
  },
  {
    id: "member_progress",
    name: "member-progress",
    roles: clubRoles,
  },
  // {
  //   id: "group_goal_tracking",
  //   name: "group-goal-tracking",
  //   roles: ["advanced-facilitator", "certified-facilitator", "advanced-facilitator-trainee"],
  // },
];

const selectedTab = ref("summary");
let activeTab = "summary";

const isDeleteClubModalOpen = ref(false);
const isDateChangeModalOpen = ref(false);
const isStudentNoteModalOpen = ref(false);
const isSavingStudentNote = ref(false);
const isNoteModalOpen = ref(false);

const club = ref({} as Club);
const notes = ref([] as ClubNote[]);
const students = ref([] as Student[]);
const attendance = ref([] as Attendance[]);

const noteModalMode = ref("create");
const selectedNote = ref({} as ClubNote | null);
const selectedStudent = ref("" as Student["id"]);
const selectedDateId = ref({} as ClubDate["id"]);

const updateDateDate = ref(new Date());
const updateDateID = ref({} as ClubDate["id"]);

const isDownloadingReport = ref(false);
const showGoalNagBanner = ref(false);

const notesDates = ref([] as ClubDate[]);

const userCanEdit = computed(() => {
  if (user.value.id === club.value.user_id) {
    console.log(`Club owner`);
    return true;
  }

  if (userHasRole(user.value.roles, ["facilitator-organisation"]) && user.value.organisation_id === club.value.organisation_id) {
    console.log(`Facilitator in organisation`);
    return true;
  }

  if (userIsAdmin.value) {
    console.log(`Admin`);
    return true;
  }

  console.log(`No permission`);
  return false;
});

const userCanSeeSmartSurvey = computed(() => {
  if (userHasRole(user.value.roles, ["admin", "clubs-admin"])) {
    return true;
  }

  if (userHasRole(user.value.roles, ["advanced-facilitator", "certified-facilitator"]) && user.value.id === club.value.user_id) {
    return true;
  }

  if (userHasRole(user.value.roles, ["facilitator-organisation"]) && user.value.organisation_id === club.value.organisation_id) {
    return true;
  }

  return false;
});

const studentsMissingConsent = computed(() => {
  return students.value.filter(student => student.survey_permission === false);
});

const studentsToOutput = computed(() => {
  if (!userHasRole(user.value.roles, ["parent", "brick-club-family"])) {
    return students.value;
  }
  return students.value.filter(student => student.survey_permission === true);
});

function getSessionFeedbackScore(session: any) {
  let total = 0;

  if (session.checklist_score_environment) {
    total += session.checklist_score_environment;
  }

  if (session.checklist_score_facilitation) {
    total += session.checklist_score_facilitation;
  }

  if (session.checklist_score_member_experiences) {
    total += session.checklist_score_member_experiences;
  }

  if (session.checklist_score_brick_club_creations) {
    total += session.checklist_score_brick_club_creations;
  }

  return total;
}

async function updateClubVisibility(visibility: string) {
  try {
    const response = await api.clubs.updateClubVisibility(club.value.id, {
      status: visibility,
    });
    club.value.visibility = response.data.club.visibility;

    club.value = (await api.clubs.getClub(Number(route.params.id))).data.club;

    globalStore.toast("SUCCESS", "Club visibility updated");
  } catch (e) {
    globalStore.toast("ERROR", "There was an error updating Club visibility");
  }
}

async function deleteClub() {
  try {
    await api.clubs.deleteClub(club.value.id);

    globalStore.toast("SUCCESS", "Club deleted");
    return router.push(`/dashboard/clubs`);
  } catch (e) {
    globalStore.toast("ERROR", "There was an error deleting Club");
  }
}

function showDateChangeModal(date: Date, brick_club_date_id: number) {
  if (!date) return;
  updateDateDate.value = date;
  updateDateID.value = brick_club_date_id;
  isDateChangeModalOpen.value = true;
}

function resetTable() {
  fetchClub();
  isDateChangeModalOpen.value = false;
}

async function setDate() {
  const date = updateDateDate.value;
  const brick_club_date_id = updateDateID.value;

  try {
    const response = await api.clubs.updateClubDate(club.value.id, brick_club_date_id, {
      date: date,
    });

    club.value.dates.find(i => i.id === brick_club_date_id)!.date = response.data.clubDate.date;
    globalStore.toast("SUCCESS", "Date updated");
  } catch (e) {
    globalStore.toast("ERROR", "There was an error updating date");
  }
  isDateChangeModalOpen.value = false;
}

/** Brick Club Notes */
async function openNoteModal(mode: string, note?: ClubNote) {
  noteModalMode.value = mode;

  if (mode === "update") {
    selectedNote.value = note!;
  }

  if (mode === "create") {
    selectedNote.value = null;
  }

  isNoteModalOpen.value = true;

  await getMissingGoalProgressDates();
}

async function listClubNotes() {
  if (club.value.user_id === user.value.id || userIsAdmin || userHasRole(user.value.roles, ["facilitator-organisation"])) {
    notes.value = (await api.clubs.listClubNotes(Number(route.params.id))).data.notes;
  }
}

async function createClubNote(brick_club_date_id: number, content: string) {
  try {
    await api.clubs.createClubNote(club.value.id, {
      brick_club_id: club.value.id,
      brick_club_date_id: brick_club_date_id,
      content: content,
    });

    globalStore.toast("SUCCESS", "Note created");

    await listClubNotes();
    isNoteModalOpen.value = false;
  } catch (error) {
    console.log(error);
    globalStore.toast("ERROR", "Error adding Note");
  }
}

async function editClubNote(id: ClubNote["id"], brick_club_date_id: number, content: string) {
  try {
    await api.clubs.updateClubNote(club.value.id, id, {
      brick_club_id: club.value.id,
      brick_club_date_id: brick_club_date_id,
      content: content,
    });

    globalStore.toast("SUCCESS", "Note updated");

    await listClubNotes();
    isNoteModalOpen.value = false;
  } catch (error) {
    console.log(error);
    globalStore.toast("ERROR", "Error updating Note");
  }
}

async function createStudentNote(brick_club_date_id: number, content: string, show_parent: boolean) {
  try {
    isSavingStudentNote.value = true;
    await api.students.createStudentNote(club.value.id, selectedStudent.value, {
      brick_club_id: club.value.id,
      brick_club_date_id: brick_club_date_id,
      content: content,
      show_parent: show_parent,
      student_id: selectedStudent.value,
    });

    globalStore.toast("SUCCESS", "Note created");
  } catch (error) {
    console.log(error);
    globalStore.toast("ERROR", "Error adding Note");
  } finally {
    isStudentNoteModalOpen.value = false;
  }
}

/** Club Attendance */
async function listClubAttendance() {
  attendance.value = (await api.clubs.listClubAttendance(club.value.id)).data.attendance;
}

async function markStudentAttendance(student: Student, date: ClubDate) {
  try {
    const student_attendance = attendance.value.find(i => i.student_id === student.id && i.brick_club_date_id === date.id)!;

    (
      await api.clubs.markStudentAttendance(club.value.id, {
        attended: !student_attendance.attended,
        date_id: student_attendance.brick_club_date_id,
        student_id: student_attendance.student_id,
      })
    ).data.attendance;

    await listClubAttendance();
    globalStore.toast("SUCCESS", "Attendance updated");
  } catch (error) {
    globalStore.toast("ERROR", "Error marking Attendance");
  }
}

async function fetchClub() {
  try {
    club.value = (await api.clubs.getClub(Number(route.params.id))).data.club;
  } catch (error) {
    globalStore.toast("ERROR", "Error fetching Club");
    window.location.href = "/error";
  }

  await listClubNotes();

  /** Fetch all members and attendance if user is current role */
  if (userHasRole(user.value.roles, ["advanced-facilitator", "admin", "trainer-organisation", "certified-facilitator", "facilitator-organisation", "clubs-admin"])) {
    const response = await api.clubs.listClubStudents("all", club.value.id);
    students.value = response.data.students;

    await listClubAttendance();

    if (club.value.dates.length) {
      selectedDateId.value = club.value.dates[0].id;
    }
  }

  /** Fetch only parent's child attendance and feedback */
  if (userHasRole(user.value.roles, ["parent", "brick-club-family"])) {
    const response = await api.students.listStudentsByParent(user.value.id, club.value.id);

    students.value = response.data.students;
    attendance.value = (await api.students.listParentStudentsAttenance(user.value.id, club.value.id)).data.attendance;
  }

  if (route.query.tab) {
    selectedTab.value = route.query.tab;
  }
  isLoading.value = false;
}

async function getBrickGoalReport() {
  isDownloadingReport.value = true;
  const reportUrl = await api.goals.generateBrickClubReport(club.value.id);
  if (reportUrl) {
    isDownloadingReport.value = false;
    window.open(reportUrl.data.report, "_blank");
  }
}

async function shouldShowNagBanner() {
  showGoalNagBanner.value = false;
  const goalsData = await api.goals.listAllGoalsInClub(club.value.id, "all", "all");
  if (goalsData) {
    showGoalNagBanner.value = goalsData.data.showNagBanner;
  }
}

async function getMissingGoalProgressDates() {
  console.log("Getting missing notes dates");
  const response = await api.surveys.getMissingNotesDates(club.value.id);
  console.log("Missing notes dates", JSON.stringify(response.data.missingDates));
  notesDates.value = response.data.missingDates;
  // club.value.dates = response.data.dates;
}

;(
  ([__temp,__restore] = _withAsyncContext(() => fetchClub())),
  await __temp,
  __restore()
);
;(
  ([__temp,__restore] = _withAsyncContext(() => shouldShowNagBanner())),
  await __temp,
  __restore()
);

onMounted(() => {
  if (!user.value.has_brick_club_access) {
    return (window.location.href = "/dashboard");
  }

  selectedTab.value = route.query.tab ? (route.query.tab as string) : "summary";

  setInterval(async () => {
    //Only call the following if the current tab on the page is evaluation
    if (activeTab !== "session_notes") {
      return;
    }
    console.log("Polling for note/survey checklist data");
    await fetchClub();
  }, 10000);
});

// Watch for changes to the selectedTab and log the current tab to the console
watch(selectedTab, async newTab => {
  console.log("active tab:", newTab);
  activeTab = newTab;
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ClubNoteModal, {
      isOpen: isNoteModalOpen.value,
      mode: noteModalMode.value,
      note: selectedNote.value,
      dates: notesDates.value,
      onCreate: createClubNote,
      onUpdate: editClubNote,
      onKeydown: _cache[0] || (_cache[0] = _withKeys(($event: any) => (isNoteModalOpen.value = false), ["escape"])),
      onRequestMissingNotesDates: getMissingGoalProgressDates,
      onClose: _cache[1] || (_cache[1] = ($event: any) => (isNoteModalOpen.value = false))
    }, null, 8, ["isOpen", "mode", "note", "dates"]),
    _createVNode(StudentNoteModal, {
      isOpen: isStudentNoteModalOpen.value,
      mode: "create",
      dates: club.value.dates ? club.value.dates.sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime()) : [],
      isSavingNote: isSavingStudentNote.value,
      onCreate: createStudentNote,
      onKeydown: _cache[2] || (_cache[2] = _withKeys(($event: any) => (isStudentNoteModalOpen.value = false), ["escape"])),
      onClose: _cache[3] || (_cache[3] = ($event: any) => (isStudentNoteModalOpen.value = false))
    }, null, 8, ["isOpen", "dates", "isSavingNote"]),
    _createVNode(ConfirmationModal, {
      buttonText: "Delete Brick Club",
      class: "danger",
      isOpen: isDeleteClubModalOpen.value,
      onDelete: deleteClub,
      onClose: _cache[4] || (_cache[4] = ($event: any) => (isDeleteClubModalOpen.value = false))
    }, {
      default: _withCtx(() => [
        _hoisted_1,
        _createElementVNode("p", null, _toDisplayString(_ctx.$t("club-delete-confirmation")), 1)
      ]),
      _: 1
    }, 8, ["isOpen"]),
    _createVNode(ConfirmationModal, {
      buttonText: "Update Date",
      class: "danger",
      isOpen: isDateChangeModalOpen.value,
      onDelete: _cache[5] || (_cache[5] = ($event: any) => (setDate())),
      onClose: _cache[6] || (_cache[6] = ($event: any) => (resetTable()))
    }, {
      default: _withCtx(() => [
        _hoisted_2,
        _createElementVNode("p", null, _toDisplayString(_ctx.$t("attendance-change-warning-message")), 1)
      ]),
      _: 1
    }, 8, ["isOpen"]),
    (!isLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(TitleHeader, {
              title: club.value.name
            }, null, 8, ["title"]),
            (club.value.bookable || club.value.visibility)
              ? (_openBlock(), _createBlock(ExternalLink, {
                  key: 0,
                  type: "text",
                  href: `${_unref(website_url)}/for-parents-and-carers/brick-club-directory/`,
                  label: _ctx.$t('view-brick-club-on-website')
                }, null, 8, ["href", "label"]))
              : _createCommentVNode("", true)
          ]),
          _createVNode(RoleGuard, { roles: ['admin', 'advanced-facilitator', 'clubs-admin', 'certified-facilitator', 'facilitator-organisation', 'advanced-facilitator-trainee'] }, {
            default: _withCtx(() => [
              _createVNode(ClubVisibilitySwitch, {
                club: club.value,
                onChange: updateClubVisibility
              }, null, 8, ["club"])
            ]),
            _: 1
          }),
          (_unref(user).id === club.value.user_id && _unref(user).has_smartsurvey_access)
            ? (_openBlock(), _createBlock(AlertCard, {
                key: 0,
                type: "warning",
                hideIcon: "",
                class: "mt-4"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", null, [
                      _createElementVNode("p", _hoisted_6, [
                        _createElementVNode("strong", null, _toDisplayString(_ctx.$t("register-attendance")), 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t("and")) + " ", 1),
                        _createElementVNode("strong", null, _toDisplayString(_ctx.$t("make-notes")), 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t("brick-club-register-drop-in-1")) + " ", 1),
                        _createElementVNode("strong", null, _toDisplayString(_ctx.$t("feedback-surveys")), 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t("and")) + " ", 1),
                        _createElementVNode("strong", null, _toDisplayString(_ctx.$t("goal-tracking-tool")), 1),
                        _createTextVNode(". ")
                      ]),
                      _createElementVNode("p", null, [
                        _createTextVNode(_toDisplayString(_ctx.$t("brick-club-register-drop-in-2")) + " ", 1),
                        _createElementVNode("a", {
                          href: `https://playincluded.com/courses/register-for-a-training-course/33/`,
                          target: "_blank",
                          class: "text-link"
                        }, _toDisplayString(_ctx.$t("here")), 9, _hoisted_7),
                        _createTextVNode(". ")
                      ])
                    ])
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_unref(user).id === club.value.user_id && _unref(user).has_smartsurvey_access && showGoalNagBanner.value)
            ? (_openBlock(), _createBlock(AlertCard, {
                key: 1,
                type: "warning",
                hideIcon: "",
                class: "mt-4"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", null, [
                      _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t("nag-banner")), 1)
                    ]),
                    _createVNode(RouterButton, {
                      to: { name: 'Member_Outcomes' },
                      type: "primary",
                      loading: false,
                      disabled: false
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("record-member-feedback")), 1)
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (!isLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createVNode(TabGroup, {
            tabs: tabs,
            selectedTab: selectedTab.value,
            onSelect: _cache[7] || (_cache[7] = (tab) => selectedTab.value = tab),
            "has-role-guard": true
          }, null, 8, ["selectedTab"]),
          (selectedTab.value === 'summary')
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(ListRowItem, {
                    title: _ctx.$t('brick-club-name'),
                    capitalize: false
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", _hoisted_13, _toDisplayString(club.value.name), 1),
                      _createVNode(RoleGuard, { roles: clubRoles }, {
                        default: _withCtx(() => [
                          _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.$t("club-page-name-warning")), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["title"]),
                  _createVNode(ListRowItem, {
                    title: _ctx.$t('first-club-date'),
                    capitalize: false
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", _hoisted_15, _toDisplayString(new Date(club.value.first_club_date).toLocaleDateString()), 1)
                    ]),
                    _: 1
                  }, 8, ["title"]),
                  _createVNode(ListRowItem, {
                    title: _ctx.$t('last-club-date'),
                    capitalize: false
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", _hoisted_16, _toDisplayString(club.value.last_club_date ? new Date(club.value.last_club_date).toLocaleDateString() : ""), 1)
                    ]),
                    _: 1
                  }, 8, ["title"]),
                  _createVNode(ListRowItem, {
                    title: _ctx.$t('brick-club-contact-email'),
                    required: false
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_17, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(user).directory_email_address) = $event)),
                          class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded",
                          disabled: ""
                        }, null, 512), [
                          [_vModelText, _unref(user).directory_email_address]
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["title"]),
                  _createVNode(ListRowItem, {
                    title: _ctx.$t('brick-club-website'),
                    required: false
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("div", null, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(user).directory_website) = $event)),
                            class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded",
                            disabled: ""
                          }, null, 512), [
                            [_vModelText, _unref(user).directory_website]
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["title"]),
                  _createVNode(ListRowItem, {
                    title: _ctx.$t('venue'),
                    capitalize: false
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", _hoisted_19, _toDisplayString(club.value.address_line_one), 1),
                      _createElementVNode("p", _hoisted_20, _toDisplayString(club.value.address_line_two ? club.value.address_line_two : ""), 1),
                      _createElementVNode("p", _hoisted_21, _toDisplayString(club.value.city) + ", " + _toDisplayString(club.value.postcode), 1),
                      _createElementVNode("p", _hoisted_22, _toDisplayString(club.value.region), 1),
                      _createElementVNode("p", _hoisted_23, _toDisplayString(club.value.country), 1)
                    ]),
                    _: 1
                  }, 8, ["title"]),
                  _createVNode(RoleGuard, {
                    roles: clubRoles,
                    capitalize: false
                  }, {
                    default: _withCtx(() => [
                      _createVNode(ListRowItem, {
                        title: _ctx.$t('setting')
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("p", _hoisted_24, _toDisplayString(club.value.setting), 1)
                        ]),
                        _: 1
                      }, 8, ["title"]),
                      _createVNode(ListRowItem, {
                        title: _ctx.$t('age-range'),
                        capitalize: false
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("p", _hoisted_25, _toDisplayString(club.value.min_age) + " - " + _toDisplayString(club.value.max_age), 1)
                        ]),
                        _: 1
                      }, 8, ["title"])
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("div", _hoisted_27, [
                      _createElementVNode("h2", _hoisted_28, _toDisplayString(_ctx.$t("schedule")), 1)
                    ]),
                    _hoisted_29
                  ]),
                  _createVNode(ListRowItem, {
                    title: "Schedule",
                    flex: false
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_30, [
                        _createElementVNode("table", _hoisted_31, [
                          _createElementVNode("thead", null, [
                            _createElementVNode("tr", _hoisted_32, [
                              _createElementVNode("th", _hoisted_33, _toDisplayString(_ctx.$t("date")), 1),
                              _createElementVNode("th", _hoisted_34, _toDisplayString(_ctx.$t("start-time")), 1),
                              _createElementVNode("th", _hoisted_35, _toDisplayString(_ctx.$t("end-time")), 1),
                              _createElementVNode("th", _hoisted_36, _toDisplayString(_ctx.$t("timezone")), 1)
                            ])
                          ]),
                          _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(club.value.dates, (date, index) => {
                              return (_openBlock(), _createElementBlock("tr", {
                                class: "border-b border-gray-400 divide-x-2 divide-gray-400 odd:bg-gray-200",
                                key: index
                              }, [
                                _createElementVNode("td", _hoisted_37, _toDisplayString(_unref(zonedTimeToUtc)(date.date, _unref(timezone)).toDateString()), 1),
                                _createElementVNode("td", _hoisted_38, _toDisplayString(date.start_time), 1),
                                _createElementVNode("td", _hoisted_39, _toDisplayString(date.end_time), 1),
                                _createElementVNode("td", _hoisted_40, _toDisplayString(date.short_timezone), 1)
                              ]))
                            }), 128))
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(RoleGuard, { roles: clubRoles }, {
                    default: _withCtx(() => [
                      _createVNode(ListRowItem, {
                        title: _ctx.$t('participants-count'),
                        capitalize: false
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("p", _hoisted_41, _toDisplayString(club.value.participants_count), 1)
                        ]),
                        _: 1
                      }, 8, ["title"])
                    ]),
                    _: 1
                  })
                ]),
                (_unref(userCanEdit))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                      _createVNode(RouterButton, {
                        type: "primary",
                        to: { name: 'Edit_Brick_Club', params: { id: club.value.id } }
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("edit-brick-club")), 1)
                        ]),
                        _: 1
                      }, 8, ["to"]),
                      (club.value.visibility)
                        ? (_openBlock(), _createBlock(ExternalLink, {
                            key: 0,
                            type: "button",
                            href: `${_unref(website_url)}/for-parents-and-carers/brick-club-directory/`,
                            label: _ctx.$t('view-brick-club-on-website')
                          }, null, 8, ["href", "label"]))
                        : _createCommentVNode("", true),
                      _createVNode(RoleGuard, { roles: ['admin', 'clubs-admin'] }, {
                        default: _withCtx(() => [
                          _createVNode(DefaultButton, {
                            type: "danger",
                            onAction: _cache[10] || (_cache[10] = ($event: any) => (isDeleteClubModalOpen.value = true))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("delete")), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (selectedTab.value === 'club_participants')
            ? (_openBlock(), _createBlock(ClubParticipantTable, {
                key: 1,
                club: club.value,
                onDelete: _cache[11] || (_cache[11] = ($event: any) => (listClubAttendance()))
              }, null, 8, ["club"]))
            : _createCommentVNode("", true),
          (selectedTab.value === 'attendance')
            ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                _createElementVNode("h2", _hoisted_44, _toDisplayString(_ctx.$t("member-attendance")), 1),
                _createVNode(RoleGuard, { "not-roles": ['brick-club-family'] }, {
                  default: _withCtx(() => [
                    _createElementVNode("p", null, _toDisplayString(_ctx.$t("club-attendance-help-text")), 1),
                    _createVNode(AlertCard, {
                      type: "warning",
                      class: "mt-2"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("attendance-change-warning-message")), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                (_unref(userHasRole)(_unref(user).roles, ['parent', 'brick-club-family']))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                      (_unref(studentsMissingConsent).length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(studentsMissingConsent), (student) => {
                              return (_openBlock(), _createElementBlock("p", {
                                key: student.id
                              }, [
                                _createTextVNode(_toDisplayString(_ctx.$t("parent-attendance-table-no-consent", [
                _unref(capitalize)(student.first_name) + (student.middle_name ? ` ${_unref(capitalize)(student.middle_name)}` : "") + " " + _unref(capitalize)(student.last_name),
              ])) + " ", 1),
                                _createVNode(_component_router_link, {
                                  to: `/dashboard/children/${student.id}`,
                                  class: "underline text-primary"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t("here")), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["to"]),
                                _createTextVNode(". ")
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (_unref(studentsToOutput).length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                      _createElementVNode("table", _hoisted_48, [
                        _createElementVNode("thead", _hoisted_49, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("th", _hoisted_50, _toDisplayString(_ctx.$t("date")), 1),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(studentsToOutput), (student) => {
                              return (_openBlock(), _createElementBlock("th", {
                                scope: "col",
                                class: "px-4 py-2 capitalize",
                                key: student.id
                              }, _toDisplayString(student.first_name) + _toDisplayString(student.middle_name ? ` ${student.middle_name}` : "") + " " + _toDisplayString(student.last_name), 1))
                            }), 128))
                          ])
                        ]),
                        (attendance.value.length)
                          ? (_openBlock(), _createElementBlock("tbody", _hoisted_51, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(club.value.dates, (date) => {
                                return (_openBlock(), _createElementBlock("tr", {
                                  class: "border-b border-gray-400",
                                  key: date.id
                                }, [
                                  _createElementVNode("td", _hoisted_52, [
                                    _createVNode(_unref(DatePicker), {
                                      class: "w-full",
                                      "onUpdate:modelValue": [e => showDateChangeModal(e, date.id), ($event: any) => ((date.date) = $event)],
                                      modelValue: date.date,
                                      required: "",
                                      "enable-time-picker": false,
                                      disabled: attendance.value.filter(i => i.brick_club_date_id === date.id && i.attended).length > 0 || _unref(userHasRole)(_unref(user).roles, ['brick-club-family']),
                                      format: "dd/MMM/yyyy"
                                    }, null, 8, ["onUpdate:modelValue", "modelValue", "disabled"])
                                  ]),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(studentsToOutput), (student) => {
                                    return (_openBlock(), _createElementBlock("td", {
                                      class: "px-4 whitespace-nowrap",
                                      key: student.id
                                    }, [
                                      (_unref(userHasRole)(_unref(user).roles, clubRoles) && attendance.value.find(i => i.student_id === student.id && i.brick_club_date_id === date.id))
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                                            (!student.survey_permission)
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_54, _toDisplayString(_ctx.$t("parent-consent-button")), 1))
                                              : _createCommentVNode("", true),
                                            _createVNode(ToggleCheckbox, {
                                              readonly: _unref(userHasRole)(_unref(user).roles, ['parent', 'brick-club-family']) || !student.survey_permission,
                                              value: attendance.value.find(i => i.student_id === student.id && i.brick_club_date_id === date.id).attended,
                                              onToggle: ($event: any) => (markStudentAttendance(student, date))
                                            }, null, 8, ["readonly", "value", "onToggle"])
                                          ]))
                                        : _createCommentVNode("", true),
                                      (_unref(userHasRole)(_unref(user).roles, ['parent', 'brick-club-family']))
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_55, _toDisplayString(attendance.value.find(i => i.student_id === student.id && i.brick_club_date_id === date.id).attended ? "Attended" : "Not attended"), 1))
                                        : _createCommentVNode("", true)
                                    ]))
                                  }), 128))
                                ]))
                              }), 128)),
                              _createElementVNode("tr", _hoisted_56, [
                                _createElementVNode("td", _hoisted_57, _toDisplayString(_ctx.$t("total-no-of-sessions")), 1),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(studentsToOutput), (student) => {
                                  return (_openBlock(), _createElementBlock("td", {
                                    class: "px-2 py-6 md:py-3 whitespace-nowrap",
                                    key: student.id
                                  }, _toDisplayString(attendance.value.filter(i => i.student_id === student.id && i.attended).length), 1))
                                }), 128))
                              ]),
                              _createElementVNode("tr", _hoisted_58, [
                                _createElementVNode("td", _hoisted_59, _toDisplayString(_ctx.$t("total-percent")), 1),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(studentsToOutput), (student) => {
                                  return (_openBlock(), _createElementBlock("td", {
                                    class: "px-2 py-6 md:py-3 whitespace-nowrap",
                                    key: student.id
                                  }, _toDisplayString(((attendance.value.filter(i => i.student_id === student.id && i.attended).length / club.value.dates.length) * 100).toFixed(2)) + "% ", 1))
                                }), 128))
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (selectedTab.value === 'session_notes')
            ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                (_unref(userCanSeeSmartSurvey))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                      (_unref(user).has_smartsurvey_access || _unref(userIsAdmin))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                            _createElementVNode("h2", _hoisted_63, _toDisplayString(_ctx.$t("facilitator-session-feedback")), 1),
                            _createElementVNode("p", null, [
                              _createTextVNode(_toDisplayString(_ctx.$t("club-page-session-feedback-1")) + " ", 1),
                              _createElementVNode("a", {
                                href: `${_unref(website_url)}/data`,
                                class: "text-blue-500 underline hover:text-blue-600",
                                target: "_blank"
                              }, _toDisplayString(_ctx.$t("here")) + ".", 9, _hoisted_64)
                            ]),
                            _createElementVNode("p", null, _toDisplayString(_ctx.$t("club-page-session-feedback-2")), 1),
                            _createElementVNode("ul", _hoisted_65, [
                              _createElementVNode("li", null, _toDisplayString(_ctx.$t("club-page-session-feedback-li-1")), 1),
                              _createElementVNode("li", null, _toDisplayString(_ctx.$t("club-page-session-feedback-li-2")), 1),
                              _createElementVNode("li", null, _toDisplayString(_ctx.$t("club-page-session-feedback-li-3")), 1),
                              _createElementVNode("li", null, _toDisplayString(_ctx.$t("club-page-session-feedback-li-4")), 1)
                            ]),
                            _createElementVNode("table", _hoisted_66, [
                              _createElementVNode("thead", _hoisted_67, [
                                _createElementVNode("tr", null, [
                                  _createElementVNode("th", _hoisted_68, _toDisplayString(_ctx.$t("date")), 1),
                                  (club.value.user_id === _unref(user).id)
                                    ? (_openBlock(), _createElementBlock("th", _hoisted_69, _toDisplayString(_ctx.$t("group-notes-for-session")), 1))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("th", _hoisted_70, _toDisplayString(_ctx.$t("session-checklist-scores")), 1)
                                ])
                              ]),
                              _createElementVNode("tbody", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(notes.value, (note) => {
                                  return (_openBlock(), _createElementBlock("tr", {
                                    class: "border-b border-gray-400",
                                    key: note.id
                                  }, [
                                    _createElementVNode("td", _hoisted_71, _toDisplayString(new Date(note.session.date).toDateString()), 1),
                                    (club.value.user_id === _unref(user).id)
                                      ? (_openBlock(), _createElementBlock("td", _hoisted_72, [
                                          _createVNode(ReadOnlyNote, {
                                            content: note.content
                                          }, null, 8, ["content"])
                                        ]))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("td", _hoisted_73, [
                                      (
                      note.session.checklist_score_environment ||
                      note.session.checklist_score_facilitation ||
                      note.session.checklist_score_member_experiences ||
                      note.session.checklist_score_brick_club_creations
                    )
                                        ? (_openBlock(), _createElementBlock("ul", _hoisted_74, [
                                            _createElementVNode("li", null, _toDisplayString(_ctx.$t("environment-and-space")) + " = " + _toDisplayString(note.session.checklist_score_environment ? note.session.checklist_score_environment : 0) + " / 8", 1),
                                            _createElementVNode("li", null, _toDisplayString(_ctx.$t("facilitator")) + " = " + _toDisplayString(note.session.checklist_score_facilitation ? note.session.checklist_score_facilitation : 0) + " / 5", 1),
                                            _createElementVNode("li", null, _toDisplayString(_ctx.$t("member-experiences")) + " = " + _toDisplayString(note.session.checklist_score_member_experiences ? note.session.checklist_score_member_experiences : 0) + " / 5", 1),
                                            _createElementVNode("li", null, _toDisplayString(_ctx.$t("brick-club-creations")) + " = " + _toDisplayString(note.session.checklist_score_brick_club_creations ? note.session.checklist_score_brick_club_creations : 0) + " / 4", 1),
                                            _createElementVNode("li", null, [
                                              _createElementVNode("span", _hoisted_75, _toDisplayString(_ctx.$t("total")), 1),
                                              _createTextVNode(" = " + _toDisplayString(getSessionFeedbackScore(note.session)) + " / 22 ", 1)
                                            ])
                                          ]))
                                        : (club.value.user_id === _unref(user).id)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_76, [
                                              _createVNode(ExternalLink, {
                                                href: `https://forms.playincluded.com/s/SessionChecklist/?bcDateId=${note.brick_club_date_id}&fId=${club.value.user_id}`,
                                                type: "text",
                                                label: _ctx.$t('complete-session-checklist')
                                              }, null, 8, ["href", "label"])
                                            ]))
                                          : _createCommentVNode("", true)
                                    ])
                                  ]))
                                }), 128)),
                                _createElementVNode("tr", _hoisted_77, [
                                  _hoisted_78,
                                  (club.value.user_id === _unref(user).id)
                                    ? (_openBlock(), _createElementBlock("td", _hoisted_79, [
                                        _createVNode(DefaultButton, {
                                          type: "text",
                                          onAction: _cache[12] || (_cache[12] = ($event: any) => (openNoteModal('create')))
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t("add-session-note")), 1)
                                          ]),
                                          _: 1
                                        })
                                      ]))
                                    : _createCommentVNode("", true)
                                ])
                              ])
                            ])
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_80, _toDisplayString(_ctx.$t("facilitator-no-smartsurvey-access")), 1))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_81, _toDisplayString(_ctx.$t("session-notes-available")), 1))
              ]))
            : _createCommentVNode("", true),
          (selectedTab.value === 'member_progress')
            ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
                (_unref(userCanSeeSmartSurvey))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
                      (_unref(user).has_smartsurvey_access || _unref(userIsAdmin))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_84, [
                            _createElementVNode("div", _hoisted_85, [
                              _createElementVNode("h2", _hoisted_86, _toDisplayString(_ctx.$t("member-progress")), 1),
                              (_unref(userCanEdit))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_87, [
                                    _createVNode(RoleGuard, { roles: ['facilitator-organisation', 'advanced-facilitator', 'certified-facilitator', 'advanced-facilitator-trainee', 'admin', 'clubs-admin'] }, {
                                      default: _withCtx(() => [
                                        _createVNode(DefaultButton, {
                                          type: "primary",
                                          onAction: getBrickGoalReport,
                                          loading: isDownloadingReport.value
                                        }, {
                                          default: _withCtx(() => [
                                            _createElementVNode("span", _hoisted_88, _toDisplayString(_ctx.$t("download-goals-report-for-club")), 1),
                                            _hoisted_89
                                          ]),
                                          _: 1
                                        }, 8, ["loading"])
                                      ]),
                                      _: 1
                                    })
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("table", _hoisted_90, [
                              _createElementVNode("thead", _hoisted_91, [
                                _createElementVNode("tr", null, [
                                  _createElementVNode("th", _hoisted_92, _toDisplayString(_ctx.$t("name")), 1),
                                  _createVNode(RoleGuard, { roles: ['advanced-facilitator', 'advanced-facilitator-trainee', 'certified-facilitator'] }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("th", _hoisted_93, _toDisplayString(_ctx.$t("member-notes")), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createElementVNode("th", _hoisted_94, _toDisplayString(_ctx.$t("member-session-feedback")), 1),
                                  _createElementVNode("th", _hoisted_95, _toDisplayString(_ctx.$t("goal-tracking")), 1)
                                ])
                              ]),
                              _createElementVNode("tbody", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(students.value, (student) => {
                                  return (_openBlock(), _createElementBlock("tr", {
                                    class: "border-b border-gray-400",
                                    key: student.id
                                  }, [
                                    _createElementVNode("td", _hoisted_96, _toDisplayString(student.first_name) + _toDisplayString(student.middle_name ? ` ${student.middle_name}` : "") + " " + _toDisplayString(student.last_name), 1),
                                    _createVNode(RoleGuard, { roles: ['advanced-facilitator', 'advanced-facilitator-trainee', 'certified-facilitator'] }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("td", _hoisted_97, [
                                          _createVNode(_component_router_link, {
                                            to: `/dashboard/club-member-outcomes/${student.id}?tab=member_notes`,
                                            class: "underline text-primary"
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(_ctx.$t("view")), 1)
                                            ]),
                                            _: 2
                                          }, 1032, ["to"])
                                        ])
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createElementVNode("td", _hoisted_98, [
                                      _createVNode(ClubStudentRouterButton, {
                                        student: student,
                                        to: `/dashboard/club-member-outcomes/${student.id}?tab=member_session_feedback`
                                      }, null, 8, ["student", "to"])
                                    ]),
                                    _createElementVNode("td", _hoisted_99, [
                                      _createVNode(ClubStudentRouterButton, {
                                        student: student,
                                        to: `/dashboard/club-member-outcomes/${student.id}?tab=goal_tracking`
                                      }, null, 8, ["student", "to"])
                                    ])
                                  ]))
                                }), 128))
                              ])
                            ])
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_100, _toDisplayString(_ctx.$t("facilitator-no-smartsurvey-access")), 1))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_101, _toDisplayString(_ctx.$t("member-progress-only-available")), 1))
              ]))
            : _createCommentVNode("", true),
          (selectedTab.value === 'group_goal_tracking')
            ? (_openBlock(), _createElementBlock("div", _hoisted_102, [
                (_unref(userCanSeeSmartSurvey) || _unref(userIsAdmin))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_103, [
                      (_unref(user).has_smartsurvey_access)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_104, [
                            _createElementVNode("h2", _hoisted_105, _toDisplayString(_ctx.$t("group-goal-tracking")), 1),
                            _createElementVNode("p", null, _toDisplayString(_ctx.$t("group-goal-tracking-helptext")), 1),
                            _createVNode(GroupGoalProgressChart, {
                              club: club.value,
                              members: students.value
                            }, null, 8, ["club", "members"])
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_106, _toDisplayString(_ctx.$t("facilitator-no-smartsurvey-access")), 1))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_107, _toDisplayString(_ctx.$t("group-goal-tracking-no-ss")), 1))
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})